'use strict';

var cookieHelpers = require('../common/cookie');

var LOCALE_COOKIE_NAME = 'mxc_locale_handoff';
var LOCALE_COOKIE_LIFETIME_HOURS = 5 / 60;
var GEO_DISMISSED_COOKIE = 'country_selector_dismissed';
var GEO_DISMISSED_COOKIE_DAYS = 30;

const SELECTORS = {
    element: '.js-country-selector',
    selectElement: '#footerCountrySelector',
    modalSelectElement: '#modalCountrySelector',
    dropdownItem: '.js-country-selector .dropdown-menu li a',
    redirectLink: '.js-country-redirect, .js-countrySelectorRedirect',
    option: '.js-country-selector-option',
    page: '.page',
    seoContent: '.js-footer-seo-content'
};

function getSharedCookieDomain(url) {
    var parsedUrl;
    var currentLabels;
    var targetLabels;
    var commonLabels = [];
    var index;

    try {
        parsedUrl = new URL(url, window.location.origin);
    } catch (error) {
        return null;
    }

    currentLabels = window.location.hostname.split('.').filter(Boolean);
    targetLabels = parsedUrl.hostname.split('.').filter(Boolean);

    if (!currentLabels.length || !targetLabels.length) {
        return null;
    }

    index = 1;
    while (
        index <= currentLabels.length
        && index <= targetLabels.length
        && currentLabels[currentLabels.length - index] === targetLabels[targetLabels.length - index]
    ) {
        commonLabels.unshift(currentLabels[currentLabels.length - index]);
        index += 1;
    }

    if (commonLabels.length < 2) {
        return null;
    }

    return '.' + commonLabels.join('.');
}

function setLocaleCookie(localeCode, currencyCode, url) {
    var cookieDomain = getSharedCookieDomain(url);
    var cookieValue = encodeURIComponent(JSON.stringify({
        localeCode: localeCode,
        currencyCode: currencyCode || 'EUR',
        explicitSelection: true,
        selectedCountry: localeCode && localeCode.indexOf('_') > -1 ? localeCode.split('_')[1] : ''
    }));
    var cookieOptions = {
        hours: LOCALE_COOKIE_LIFETIME_HOURS,
        path: '/',
        sameSite: 'Lax',
        secure: window.location.protocol === 'https:'
    };

    if (cookieDomain) {
        cookieOptions.domain = cookieDomain;
    }

    cookieHelpers.setCookie(LOCALE_COOKIE_NAME, cookieValue, cookieOptions);
}

function setGeoDismissedCookie() {
    cookieHelpers.setCookie(GEO_DISMISSED_COOKIE, '1', {
        hours: GEO_DISMISSED_COOKIE_DAYS * 24,
        path: '/',
        sameSite: 'Lax',
        secure: window.location.protocol === 'https:'
    });
}

function handleCountryRedirectClick(e) {
    var $source = $(this);
    var $countrySelector = $source.closest(SELECTORS.element);
    var isModalDropdownSelection = !$source.is(SELECTORS.redirectLink)
        && $countrySelector.length
        && $countrySelector.find(SELECTORS.modalSelectElement).length > 0;

    if (isModalDropdownSelection) {
        return;
    }

    var $content = $source.is(SELECTORS.redirectLink) ? $source : $source.find(SELECTORS.option);

    if ($content.length === 0) {
        return;
    }

    e.stopImmediatePropagation();
    e.preventDefault();

    var url = $content.data('url');
    var localeCode = $content.data('locale');
    var currencyCode = $content.data('currencycode');

    if (url && localeCode) {
        setLocaleCookie(localeCode, currencyCode, url);
        setGeoDismissedCookie();
        window.location.href = url;
    } else if (url) {
        window.location.href = url;
    }
}

module.exports = function () {
    $(document).on('click', SELECTORS.dropdownItem, handleCountryRedirectClick);
    $(document).on('click', SELECTORS.redirectLink, handleCountryRedirectClick);
};
